<template>
    <div class="space-below">
        <div class="container space">
            <div class="row ">
                <div class="col col-lg-12 col-sm-12">
                    <div class="section-title-s3">
                        <span>Our Services</span>
                        <h2>The leader in AV installation and support</h2>
                    </div>
                </div>
            </div>
        </div>

        <section>
            <div class="container">
                <div class="header-image">
                    <img src="/assets/images/services.jpg" />
                </div>
            </div>
        </section>

        <section>
            <div class="container space">
                <div class="row no-gutters">
                    <div class="col-sm-12 col-md-6  mb-3">
                        <div class="card">
                            <div class="card-body">
                                <h3>System Design and Engineering</h3>
                                <div>
                                    Our highly skilled design and drafting team apply years of field experience in combination with the newest technologies to make your vision a reality.  We will carefully consider your needs, wants, budgetary requirements, time restrictions, and structural constraints to create the most effective and affordable audio visual solution that can be seamlessly integrated into your working environment.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6  mb-3">
                        <div class="card">
                            <div class="card-body">
                                <h3>Trusted Expert Support</h3>
                                <div>
                                    Once installation is complete, Streamline can assure that you get the highest quality support and maximum usage out of your new system with our Maintenance and Support Agreements. For a manageable annual fee, we offer periodic preventative maintenance visits as well as quick response times to investigate and correct any problems that may arise.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6  mb-3">
                        <div class="card">
                            <div class="card-body">
                                <h3>Programming</h3>
                                <div>
                                    Streamline’s control system programming gives you the power to control your new AV system through user friendly, customized interfaces on touch panel displays and control panels from trusted manufacturers.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6  mb-3">
                        <div class="card">
                            <div class="card-body">
                                <h3>Installation</h3>
                                <div>
                                    Our installers are licensed, trained, and certified and have the experience and ingenuity to handle challenging situations while on any work site. They take pride in their technical prowess and are continually learning about new products and seeking to expand their skill set. We value great customer service and getting things right the first time. Our installation team will not only meticulously install your system, but also test the system to assure it is working correctly and provide training for you and your staff.
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <section>
            <testimonials></testimonials>
        </section>

    </div>
</template>
<script>
    import Testimonials from "./sections/Testimonials"
    export default {
        components: {
            Testimonials
        }
    }
</script>
<style  lang="scss" scoped>
    .row {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display:         flex;
        flex-wrap: wrap;
    }
    .row > [class*='col-'] {
        display: flex;
        flex-direction: column;

    }
    .no-gutters {
        margin-left: 0px;

    }
    .card {
        border-radius: 0px !important;
        margin: 0px;
        background-color: #fff;
    }
    .card-body {
        padding: 20px;
        width: 100%;
    }
    .card-text {
        //font-size: 80%;
        font-weight: 600;
    }
    .mb-3 {
        margin-bottom: 0px;
    }
</style>
